export default __webpack_public_path__ + "static/media/2425.c7664767.png";